import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaPaperPlane, FaCheckCircle, FaTimes } from 'react-icons/fa';
import DashboardLayout from '../../components/layout/DashboardLayout';
import './ContactUsScreen.css';

const ContactUsScreen = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setShowSuccessPopup(true);
      setFormData({ name: '', email: '', message: '' });
      setIsSubmitting(false);
    }, 1000);
  };

  const handlePhoneCall = () => {
    window.open('tel:+919938745015', '_self');
  };

  const handleEmail = () => {
    window.open('mailto:office@meeturexpert.com', '_self');
  };

  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: 'Our Office',
      details: [
        'Sahid Nagar, Bhubaneswar,',
        'Bhubaneswar, Odisha',
        'India - 560001'
      ]
    },
    {
      icon: <FaPhone />,
      title: 'Phone',
      details: ['+91 9938745015'],
      action: handlePhoneCall
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      details: ['office@meeturexpert.com'],
      action: handleEmail
    },
    {
      icon: <FaClock />,
      title: 'Working Hours',
      details: [
        'Monday - Friday: 9:00 AM - 8:00 PM',
        'Saturday: 10:00 AM - 6:00 PM',
        'Sunday: 10:00 AM - 2:00 PM (Emergency Support)'
      ]
    }
  ];

  return (
    <DashboardLayout title="Contact Us" showBackButton={true}>
      <div className="contact-us-container">
        {/* Header */}
        <div className="contact-header">
          <h1 className="contact-title">Contact Expert Support</h1>
          <p className="contact-subtitle">
            Need assistance with your practice management? Our expert support team is here to help healthcare professionals succeed.
          </p>
        </div>

        {/* Contact Info Grid */}
        <div className="contact-info-grid">
          {contactInfo.map((info, index) => (
            <div 
              key={index} 
              className={`contact-info-card ${info.action ? 'clickable' : ''}`}
              onClick={info.action}
            >
              <div className="contact-info-icon">
                {info.icon}
              </div>
              <div className="contact-info-content">
                <h3 className="contact-info-title">{info.title}</h3>
                <div className="contact-info-details">
                  {info.details.map((detail, idx) => (
                    <p key={idx} className="contact-info-text">{detail}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Form */}
        <div className="contact-form-section">
          <div className="form-header">
            <h2 className="form-title">Get Professional Support</h2>
            <p className="form-subtitle">
              Have questions about practice management, technical issues, or need feature assistance? Our team is ready to help.
            </p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter your full name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email" className="form-label">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter your email address"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className="form-textarea"
                placeholder="Enter your message"
                rows="5"
                required
              ></textarea>
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <div className="button-spinner"></div>
                  Sending...
                </>
              ) : (
                <>
                  <FaPaperPlane />
                  Send Message
                </>
              )}
            </button>
          </form>
        </div>

        {/* Quick Contact Buttons */}
        <div className="quick-contact-section">
          <h3 className="quick-contact-title">Quick Contact</h3>
          <div className="quick-contact-buttons">
            <button className="quick-contact-btn phone-btn" onClick={handlePhoneCall}>
              <FaPhone />
              <span>Call Us</span>
            </button>
            <button className="quick-contact-btn email-btn" onClick={handleEmail}>
              <FaEnvelope />
              <span>Email Us</span>
            </button>
          </div>
        </div>

        {/* Success Popup */}
        {showSuccessPopup && (
          <div className="success-popup-overlay">
            <div className="success-popup">
              <div className="success-popup-header">
                <div className="success-icon">
                  <FaCheckCircle />
                </div>
                <button 
                  className="popup-close-btn"
                  onClick={() => setShowSuccessPopup(false)}
                >
                  <FaTimes />
                </button>
              </div>
              <div className="success-popup-content">
                <h3>Message Sent Successfully!</h3>
                <p>Thank you for contacting us. Our expert support team will respond to your inquiry within 24 hours.</p>
                <button 
                  className="popup-ok-btn"
                  onClick={() => setShowSuccessPopup(false)}
                >
                  Got it!
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ContactUsScreen;